var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "goods-manage" },
    [
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _c("el-input", {
            staticClass: "filter-item",
            staticStyle: { width: "200px" },
            attrs: { placeholder: "订单号", clearable: "" },
            nativeOn: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.handleFilter($event)
              },
            },
            model: {
              value: _vm.listQuery.orderSn,
              callback: function ($$v) {
                _vm.$set(_vm.listQuery, "orderSn", $$v)
              },
              expression: "listQuery.orderSn",
            },
          }),
          _vm._v(" "),
          _c("el-input", {
            staticClass: "filter-item",
            staticStyle: { width: "200px" },
            attrs: { placeholder: "蓝票请求流水号", clearable: "" },
            nativeOn: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.handleFilter($event)
              },
            },
            model: {
              value: _vm.listQuery.invoiceReqSn,
              callback: function ($$v) {
                _vm.$set(_vm.listQuery, "invoiceReqSn", $$v)
              },
              expression: "listQuery.invoiceReqSn",
            },
          }),
          _vm._v(" "),
          _c("el-input", {
            staticClass: "filter-item",
            staticStyle: { width: "200px" },
            attrs: { placeholder: "红票请求流水号", clearable: "" },
            nativeOn: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.handleFilter($event)
              },
            },
            model: {
              value: _vm.listQuery.redInvoiceReqSn,
              callback: function ($$v) {
                _vm.$set(_vm.listQuery, "redInvoiceReqSn", $$v)
              },
              expression: "listQuery.redInvoiceReqSn",
            },
          }),
          _vm._v(" "),
          _c(
            "el-select",
            {
              staticStyle: { width: "200px" },
              attrs: {
                placeholder: "是否存在红票",
                clearable: "",
                filterable: "",
              },
              model: {
                value: _vm.listQuery.redFlag,
                callback: function ($$v) {
                  _vm.$set(_vm.listQuery, "redFlag", $$v)
                },
                expression: "listQuery.redFlag",
              },
            },
            [
              _c("el-option", { key: "1", attrs: { label: "是", value: "1" } }),
              _vm._v(" "),
              _c("el-option", { key: "0", attrs: { label: "否", value: "0" } }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-select",
            {
              staticStyle: { width: "200px" },
              attrs: { placeholder: "订单类型", clearable: "", filterable: "" },
              model: {
                value: _vm.listQuery.orderType,
                callback: function ($$v) {
                  _vm.$set(_vm.listQuery, "orderType", $$v)
                },
                expression: "listQuery.orderType",
              },
            },
            [
              _c("el-option", {
                key: "1",
                attrs: { label: "点餐订单", value: "1" },
              }),
              _vm._v(" "),
              _c("el-option", {
                key: "2",
                attrs: { label: "虚拟订单", value: "2" },
              }),
              _vm._v(" "),
              _c("el-option", {
                key: "3",
                attrs: { label: "储值订单", value: "3" },
              }),
              _vm._v(" "),
              _c("el-option", {
                key: "4",
                attrs: { label: "预约订单", value: "4" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-select",
            {
              staticStyle: { width: "200px" },
              attrs: { placeholder: "发票状态", clearable: "", filterable: "" },
              model: {
                value: _vm.listQuery.status,
                callback: function ($$v) {
                  _vm.$set(_vm.listQuery, "status", $$v)
                },
                expression: "listQuery.status",
              },
            },
            [
              _c("el-option", {
                key: "0",
                attrs: { label: "申请中", value: "0" },
              }),
              _vm._v(" "),
              _c("el-option", {
                key: "1",
                attrs: { label: "已审核", value: "1" },
              }),
              _vm._v(" "),
              _c("el-option", {
                key: "2",
                attrs: { label: "已开具", value: "2" },
              }),
              _vm._v(" "),
              _c("el-option", {
                key: "3",
                attrs: { label: "已冲红", value: "3" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              directives: [{ name: "waves", rawName: "v-waves" }],
              staticClass: "filter-item",
              attrs: { type: "primary", icon: "el-icon-search" },
              on: { click: _vm.handleFilter },
            },
            [_vm._v("\n      搜索\n    ")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.handleClickTab },
          model: {
            value: _vm.listQuery.activeName,
            callback: function ($$v) {
              _vm.$set(_vm.listQuery, "activeName", $$v)
            },
            expression: "listQuery.activeName",
          },
        },
        [
          _c("el-tab-pane", { attrs: { label: "发票列表", name: "blue" } }, [
            _vm._v("发票列表"),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          key: _vm.tableKey,
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.dataList,
            stripe: "",
            border: "",
            fit: "",
            "highlight-current-row": "",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              label: "蓝票请求流水号",
              prop: "invoiceReqSn",
              align: "center",
              "min-width": "150",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "订单号",
              prop: "orderSns",
              align: "center",
              "min-width": "150",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", [
                      !scope.row.orderSns || !scope.row.orderSns.includes(",")
                        ? _c("span", [_vm._v(_vm._s(scope.row.orderSns))])
                        : _c(
                            "div",
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(scope.row.orderSns.split(",")[0]) +
                                    "..."
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "text", size: "small" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.showOrderList(
                                        scope.row.orderSns
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              查看全部\n            "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "蓝票号码",
              prop: "invoiceNo",
              align: "center",
              "min-width": "80",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "蓝票代码",
              prop: "einvoiceNo",
              align: "center",
              "min-width": "100",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "开票金额",
              prop: "amount",
              align: "center",
              width: "110",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _vm._v("\n        ￥" + _vm._s(row.amount) + "\n      "),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "蓝票状态", align: "center", width: "80" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("span", [
                      _vm._v(_vm._s(_vm._f("statusFilter")(row.status))),
                    ]),
                    _c("br"),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "企业名称",
              prop: "companyName",
              align: "center",
              "min-width": "150",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "企业税号",
              prop: "taxCode",
              align: "center",
              "min-width": "130",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "红票请求流水号",
              prop: "redInvoiceReqSn",
              align: "center",
              "min-width": "150",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "订单类型", align: "center", width: "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("span", [
                      _vm._v(_vm._s(_vm._f("orderTypeFilter")(row.orderType))),
                    ]),
                    _c("br"),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "蓝票申请时间",
              prop: "addtime",
              align: "center",
              width: "120",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    row.addTime
                      ? _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("parseTime")(
                                row.addTime,
                                "{y}-{m}-{d} {h}:{i}:{s}"
                              )
                            )
                          ),
                        ])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "蓝票更新时间",
              prop: "upTime",
              align: "center",
              width: "120",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    row.upTime
                      ? _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("parseTime")(
                                row.upTime,
                                "{y}-{m}-{d} {h}:{i}:{s}"
                              )
                            )
                          ),
                        ])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              fixed: "right",
              label: _vm.$t("tableFrom.Operation"),
              align: "center",
              "min-width": "150",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c(
                      "div",
                      { staticClass: "operation-buttons" },
                      [
                        row.ext && !row.redInvoiceId && !row.redExt
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "primary",
                                  size: "mini",
                                  loading: _vm.downloadingRow === row.invoiceId,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleDownload(row, row.ext)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.downloadingRow === row.invoiceId
                                        ? "下载中..."
                                        : "下载蓝票"
                                    ) +
                                    "\n          "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "operation-buttons" },
                      [
                        row.redExt
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "danger",
                                  size: "mini",
                                  loading: _vm.downloadingRow === row.invoiceId,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleDownload(row, row.redExt)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.downloadingRow === row.invoiceId
                                        ? "下载中..."
                                        : "下载红票"
                                    ) +
                                    "\n          "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "订单号列表",
            visible: _vm.orderListDialogVisible,
            width: "500px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.orderListDialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "order-list-container" },
            _vm._l(_vm.orderSnList, function (orderSn, index) {
              return _c(
                "el-tag",
                {
                  key: index,
                  staticStyle: { margin: "5px", color: "#000000" },
                  attrs: { type: "primary", size: "medium" },
                },
                [_vm._v("\n        " + _vm._s(orderSn) + "\n      ")]
              )
            }),
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.orderListDialogVisible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pagination-container" },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              layout: "total, sizes, prev, pager, next, jumper",
              "current-page": _vm.listQuery.page,
              "page-size": _vm.listQuery.limit,
              "page-sizes": [10, 20, 50, 100],
              total: _vm.total,
            },
            on: {
              "current-change": _vm.handleCurrentChange,
              "size-change": _vm.handleSizeChange,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }